import styled from 'styled-components';

import media from '../../../styles/media.style';
import { BG_GRAY, SCREEN_LOCKUP_WIDTH } from '../../../styles/variables.style';

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  padding: 20px 0;
  width: 100%;

  main div section ~ & {
    ${'' /* needs to be more precise than global
    accounts for previous section bottom margin */} margin-top: 4em;

    ${media.tabletL`
      margin-top: -29em;
    `};
  }

  h5 {
    position: relative;
    margin: 0 0 4em;
    text-align: center;
    text-transform: uppercase;

    &::after {
      content: '';
      position: absolute;
      bottom: -18px;
      left: 50%;
      transform: translateX(-50%);
      background-color: ${BG_GRAY.COMMON_8};
      height: 3px;
      width: 40px;
    }
  }

  ${media.tabletL`
    align-items: center;
    padding: 40px 0;
  `};
`;

export const VideoWrapper = styled.div`
  width: 100%;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
`;



// WEBPACK FOOTER //
// ./src/pages/ProductPage/ProductInstruction/ProductInstruction.style.js